// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.
import { AbortablePromise } from "../utils.ts";
export function spawnOpenSCAD(invocation, streamsCallback) {
    let worker;
    let rejection;
    function terminate() {
        if (!worker) {
            return;
        }
        worker.terminate();
        worker = null;
    }
    return AbortablePromise((resolve, reject) => {
        worker = new Worker('./openscad-worker.js'); //, { type: 'module' });
        rejection = reject;
        worker.onmessage = (e) => {
            if ('result' in e.data) {
                resolve(e.data.result);
                terminate();
            }
            else {
                streamsCallback(e.data);
            }
        };
        worker.postMessage(invocation);
        return () => {
            terminate();
        };
    });
}
